module.exports = __webpack_public_path__ + "static/media/detail21.30f09efb.jpg";